import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { bindActionCreators } from "redux"
import i18n, { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "../../i18next"
import { fetchCodeTables } from "../common/redux/actions"
import { fetchAllLg } from "../home/redux/actions"
import { fetchUserinfo } from "./redux/actions"
import { LoginPage } from "."

export class RequireAuthenticated extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
  }

  componentDidMount() {
    const authToken = this.props.auth.authToken
    if (authToken) {
      this.props.actions.fetchCodeTables()
      this.props.actions.fetchAllLg(authToken)
      this.props.actions.fetchUserinfo(authToken)
    }
  }

  render() {
    i18n.changeLanguage(chooseLanguage(this.props))

    if (this.props.auth.authToken) {
      return this.props.children
    } else {
      return <LoginPage />
    }
  }
}

function chooseLanguage(props) {
  if (props.auth.authToken) {
    return props.auth.lang || DEFAULT_LANGUAGE
  } else {
    const browserLanguages = window.navigator.languages
    const bestLanguage = browserLanguages.find(lang => SUPPORTED_LANGUAGES.find(l => l === lang))
    return bestLanguage || DEFAULT_LANGUAGE
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    auth: state.auth,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchCodeTables, fetchAllLg, fetchUserinfo }, dispatch),
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(RequireAuthenticated),
)



// WEBPACK FOOTER //
// ./src/features/auth/RequireAuthenticated.js